module.exports = __webpack_public_path__ + "static/media/close.6834532c.svg";